import LayoutNoFooter from '@/page/layout/index'

export default [
    {
        path: '/leave-school',
        name: 'leaveSchool',
        component: LayoutNoFooter,
        children: [
            {
                path: 'index',
                name: 'leaveSchoolIndex',
                component: () => import(/* webpackChunkName: "big-screen" */ '@/views/leave-school/index'),
                meta: {
                    title: '班级放学',
                    isAuth: true,
                }
            }
        ]
    },
]
